import React,{ useRef } from 'react';
import axios from 'axios'
import { Table, Input, Button,Collapse,Avatar,Modal,Form,DatePicker,Select,Switch,Space,Typography,Divider,InputNumber,message,Spin,Popover,Popconfirm } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon, { PrinterOutlined, MinusOutlined, CloseCircleFilled, CheckCircleOutlined, UserOutlined,DeleteOutlined,EditOutlined } from '@ant-design/icons';
import { SearchOutlined,CameraOutlined,PlusOutlined,LoadingOutlined,DownloadOutlined,MailFilled } from '@ant-design/icons';
import QrReader from 'react-qr-reader'
import uuid from 'react-uuid'
import PhoneInput from 'react-phone-number-input'
import moment from 'moment';
import PrintTemplate from 'react-print';
import ReactToPrint from 'react-to-print';
import * as serverconfig from '../serverconn'
import CurrencyFormat from 'react-currency-format';
import * as reactstrp from 'reactstrap';

import {
  Col,
  Row,
} from 'reactstrap';
import '../tablestyle.css'; // Create this CSS file for custom styles
import ReactExport from "@ibrahimrahmani/react-export-excel";

var CryptoJS = require("crypto-js");

const FormItem=Form.Item;
const { Option } = Select;
const dateFormat = 'DD/MM/YYYY';
const { Title } = Typography;
const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


var sacco= ''
var bizuserid= ''
var token= ''

class ReportToPrint extends React.Component {

    state = {
      companyprofile:{},
    };
  
    componentDidMount(){

      if(localStorage.getItem("sacco")){
         sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
         bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
      
      }else{
         sacco= ''
         bizuserid= ''
      }
      
      if(localStorage.getItem("token")){
         token= localStorage.getItem("token")
      }else{
         token= ''
      }


      axios.defaults.headers={
        "Content-Type":"application/json",
        Authorization:`Token ${token}`
      }

      axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
      .then(res => {  
          this.setState({
            companyprofile: res.data
          })
  
      })

  
    }
  
    render() {
      return (
        <div style={{padding:20}}>
 <Row> 
                <Col xs="2" sm="2" lg="2">
                <img height="100" width="120"  alt="Logo" src={this.state.companyprofile.sacco_logo} />
              
                  </Col>
                  <Col xs="6" sm="6" lg="6">
                  <h3>{this.state.companyprofile.sacco_name}</h3>
                  <h6>Tel: {this.state.companyprofile.RegisteredPhoneNumber1}
                  {
                  this.state.companyprofile.RegisteredPhoneNumber2==""?
                  "":","+this.state.companyprofile.RegisteredPhoneNumber2
                  }
                  {
                  this.state.companyprofile.RegisteredPhoneNumber3==""?
                  "":","+this.state.companyprofile.RegisteredPhoneNumber3
                  }
                  </h6>               
                  <h5>Email: {this.state.companyprofile.company_email}</h5>
                  <h5>Wesite: {this.state.companyprofile.website}</h5>
                  <h5>{this.state.companyprofile.box_number}</h5>
                
                  </Col>
           </Row>

             <h3 style={{display: 'flex',justifyContent:'center', alignItems:'center',fontWeight:'bolder'}}>FINANCIAL STATEMENT REPORT FOR {this.props.selectedmemberobject.AccountNumber} | {this.props.selectedmemberobject.FullName} FROM: {this.props.dateone}  TO: {this.props.datetwo}</h3>
             
             <reactstrp.Table bordered>
        <thead>
          <tr>
            <th>No</th>
            <th>Date</th>
            <th>Desc</th>
            <th>Sub account</th>

            <th>Debit</th>
            <th>Credit</th>
            

            {this.props.showsavings?<th>Savings balance</th>:null}
            {this.props.showsavings_interest?<th>Savings interest</th>:null}

            {this.props.showshares?<th>Shares #</th>:null}
            {this.props.showshares?<th>Shares Amount</th>:null}
            {this.props.showloan?<th>Loan balance</th>:null}
            {this.props.showloan_interest?<th>Loan interest</th>:null}
            {this.props.showloan_fine? <th>Loan fine</th>:null}

            {this.props.showfixeddeposit? <th>Fixed deposit</th>:null}
            {this.props.showsavingsloansecurity? <th>Savings loan security</th>:null}
            {this.props.show_accumulateddividends? <th>Accumulated dividends</th>:null}

            <th>Journal number</th>

         

          </tr>
        </thead>
        <tbody>
        {this.props.sheetitems.map(
          (item)=>(
            <tr>
            <td>{item.item_no}</td>

            <td>{item.time_stamp}</td>
            <td>{item.description}</td>
            <td>{item.subaccount}</td>


            <td className="align-right">{<CurrencyFormat value={item.debit} displayType={'text'} thousandSeparator={true}/>}</td>
            <td className="align-right">{<CurrencyFormat value={item.credit} displayType={'text'} thousandSeparator={true}/>}</td>
           

            {this.props.showsavings?<td className="align-right">{<CurrencyFormat value={item.savings_balance} displayType={'text'} thousandSeparator={true}/>}</td>:null}
            {this.props.showsavings_interest?<td className="align-right">{<CurrencyFormat value={item.saving_interestbalance} displayType={'text'} thousandSeparator={true}/>}</td>:null}

            {this.props.showshares?<td className="align-right">{item.sharesnumber_balance} </td>:null}
            {this.props.showshares?<td className="align-right">{<CurrencyFormat value={item.sharesamount_balance} displayType={'text'} thousandSeparator={true}/>}</td>:null}
            {this.props.showloan?<td className="align-right">{<CurrencyFormat value={item.loan_balance} displayType={'text'} thousandSeparator={true}/>}</td>:null}
            {this.props.showloan_interest?<td className="align-right">{<CurrencyFormat value={item.loaninterest_balance} displayType={'text'} thousandSeparator={true}/>}</td>:null}
            {this.props.showloan_fine? <td className="align-right">{<CurrencyFormat value={item.loanfine_balance} displayType={'text'} thousandSeparator={true}/>}</td>:null}

            {this.props.showfixeddeposit? <td className="align-right">{<CurrencyFormat value={item.fixed_deposit_balance} displayType={'text'} thousandSeparator={true}/>}</td>:null}
            {this.props.showsavingsloansecurity? <td className="align-right">{<CurrencyFormat value={item.savingsloan_security_balance} displayType={'text'} thousandSeparator={true}/>}</td>:null}
            {this.props.show_accumulateddividends? <td className="align-right">{<CurrencyFormat value={item.accumulated_dividendsbalance} displayType={'text'} thousandSeparator={true}/>}</td>:null}

            <td>{item.journal_no} </td>

            </tr>
          ))}

        <tr>



        {this.props.showsavings?<td className="align-right"><h3>Savings: <CurrencyFormat  value={this.props.selectedmemberobject.savings_balance} displayType={'text'} thousandSeparator={true} /></h3> </td>:null}
            {this.props.showsavings_interest?<td className="align-right"><h3>Savings interest: <CurrencyFormat  value={this.props.selectedmemberobject.saving_interestbalance} displayType={'text'} thousandSeparator={true} /></h3> </td>:null}

            {this.props.showshares?<td className="align-right"><h3>Shares no : {this.props.selectedmemberobject.sharesnumber_balance}</h3></td>:null}
            {this.props.showshares?<td className="align-right"> <h3>Shares amount  : <CurrencyFormat  value={this.props.selectedmemberobject.sharesamount_balance} displayType={'text'} thousandSeparator={true} /></h3></td>:null}
            {this.props.showloan?<td className="align-right"><h3>Loan : <CurrencyFormat  value={this.props.selectedmemberobject.loan_balance} displayType={'text'} thousandSeparator={true} /></h3></td>:null}
            {this.props.showloan_interest?<td className="align-right"><h3>Loan interest : <CurrencyFormat  value={this.props.selectedmemberobject.loaninterest_balance} displayType={'text'} thousandSeparator={true} /></h3></td>:null}
            {this.props.showloan_fine? <td className="align-right"><h3>Loan fine : <CurrencyFormat  value={this.props.selectedmemberobject.loanfine_balance} displayType={'text'} thousandSeparator={true} /></h3></td>:null}

            {this.props.showfixeddeposit? <td className="align-right"><h3>Fixed deposit : <CurrencyFormat  value={this.props.selectedmemberobject.fixed_deposit_balance} displayType={'text'} thousandSeparator={true} /></h3></td>:null}
            {this.props.showsavingsloansecurity? <td className="align-right"><h3>Reserve (Savings loan security) : <CurrencyFormat  value={this.props.selectedmemberobject.savingsloan_security_balance} displayType={'text'} thousandSeparator={true} /></h3></td>:null}
            {this.props.show_accumulateddividends? <td className="align-right"><h3>Accumulated dividends : <CurrencyFormat  value={this.props.selectedmemberobject.accumulated_dividendsbalance} displayType={'text'} thousandSeparator={true} /></h3></td>:null}


            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>

          </tr>

      </tbody>
  </reactstrp.Table>

                <br></br>
                <h3>Generated by: {CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)}</h3>
                <h3>Powered by: www.pitech.co.ug</h3>   
        </div>
      );
    }
  }


class FinancialStatementReportPerMember extends React.Component {

  state = {
    members:[],    
    sheetitems:[],
    dateone:'',
    datetwo:'',
    selectedmemberobject:{},
    selectedmemberid:'',
    totaldebit:0,
    totalcredit:0,
    datarequested:false,
    companyprofile:{},
    userprofile:{},

    deletelist:[],

    editmodalvisiblae:false,
    selectedtranobj:{},
    credit:0,
    debit:0,
    balance:0,
    transdesc:'',

    sharesamount_balance:0,
    sharesnumber_balance:0,
    loan_balance:0,
    savingsloan_security_balance:0,
    shares_security_balance:0,

    reversalmodal_visible:false,
    selected_journal:{},
    tobereversed_transactions:[],
    loan_txn_report:[],
    general_ledger_entriesreport:[],
    txndetailsmodal_visible:false,
    userrights:{},


    showsavings:false,
    showsavings_interest:false,

    showshares:false,
    showloan:false,
    showloan_interest:false,
    showloan_fine:false,

    showsavingsloansecurity:false,
    showfixeddeposit:false,
    show_accumulateddividends:false,

    showall:false


   };

   componentDidMount(){
      if(localStorage.getItem("sacco")){
        sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
        bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
    
    }else{
        sacco= ''
        bizuserid= ''
    }
    
    if(localStorage.getItem("token")){
        token= localStorage.getItem("token")
    }else{
        token= ''
    }


    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
    .then(res => {  
        this.setState({
          companyprofile: res.data
        })

    })

    axios.get(serverconfig.backendserverurl+`/api/members_dataview/?sacco=${sacco}`)
    .then(res => {
        this.setState({
          members:res.data
        })
      })

      axios.get(`${serverconfig.backendserverurl}/api/accounts/${bizuserid}`)
      .then(res => {  
          this.setState({
            userprofile: res.data
          })
      })

      axios.get(serverconfig.backendserverurl+`/api/accountrights/?user=${bizuserid}`)
      .then(res => {
          this.setState({
            userrights:res.data[0]
          })
      })

      //mmeber change
      this.handlememberChange(Number(this.props.member_id))

  }
 
   handledatechange= (date, dateString) =>{
     this.setState({ dateone: dateString[0]});
     this.setState({ datetwo: dateString[1]});
   } 

   handlememberChange= (e) =>{
    this.setState({ selectedmemberid: e});

    axios.get(`${serverconfig.backendserverurl}/api/members_dataview/${e}`)
    .then(res => {  
        this.setState({selectedmemberobject: res.data})
    })

   } 

 
   //search sales method
   searchSales=()=>{

    let form_data = new FormData();
    form_data.append('dateone', this.state.dateone);
    form_data.append('datetwo', this.state.datetwo);
    form_data.append('memberid', this.state.selectedmemberid);
    form_data.append('sacco', sacco);

    form_data.append('showall', this.state.showall);

    form_data.append('showsavings', this.state.showsavings);
    form_data.append('showshares', this.state.showshares);

    form_data.append('showloan', this.state.showloan);
    form_data.append('showsavingsloansecurity', this.state.showsavingsloansecurity);
    form_data.append('showfixeddeposit', this.state.showfixeddeposit);

    form_data.append('showloan_interest', this.state.showloan_interest);
    form_data.append('showloan_fine', this.state.showloan_fine);
    form_data.append('showsavings_interest', this.state.showsavings_interest);
    form_data.append('show_accumulateddividends', this.state.show_accumulateddividends);

    console.log(this.state.entrant)
      
    if(this.state.selectedmemberid===''||this.state.dateone===''||this.state.datetwo===''){
      alert("Please select entrant or dates missing")
    }else{
        this.setState({datarequested:true})

        //Now submit sale data to database
        axios.post(serverconfig.backendserverurl+'/customqueries/getmemberfinancialstatement', form_data,{
        headers: {
          'content-type': 'multipart/form-data'
        }
        })
        .then(res =>{
          this.setState({datarequested:false})

            this.setState({sheetitems:JSON.parse(res.data.report)})
            this.setState({totaldebit:res.data.totalDebit})
            this.setState({totalcredit:res.data.totalCredit})
        } 
        )
        .catch(error => console.log(error))   
    }

    }

   ////////////////////////////////////
  // USER SEARCH SELECT METHODS
  onBlur=()=> {
    console.log('blur');
  }
  
   onFocus=()=>{
    console.log('focus');
  }
  
  onSearch=(val)=> {
    console.log('search:', val);
  }
 

   ////////////////////////////////////////////
   // RENDERING METHOD HERE
   render() {
       
       if(this.state.datarequested===true){
        return(
          <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
          <Spin indicator={antIcon} />
          </div>
        )
      }else{

        return(
          <div>
            <div style={{display: "none"}}>
               &nbsp;&nbsp;
              <ReportToPrint
              totaldebit={this.state.totaldebit} 
              totalcredit={this.state.totalcredit} 
              dateone={this.state.dateone}
              datetwo={this.state.datetwo}
              sheetitems={this.state.sheetitems}
              selectedmemberobject={this.state.selectedmemberobject}
              ref={el => (this.componentRef = el)}
              
              showsavings={this.state.showsavings}
              showsavings_interest={this.state.showsavings_interest}
              showshares={this.state.showshares}
              showloan={this.state.showloan}
              showloan_interest={this.state.showloan_interest}
              showloan_fine={this.state.showloan_fine}
              showsavingsloansecurity={this.state.showsavingsloansecurity}
              showfixeddeposit={this.state.showfixeddeposit}
              showall={this.state.showall}
              show_accumulateddividends={this.state.show_accumulateddividends}

              /> 
            </div>

  
            <Collapse defaultActiveKey={['1']} onChange={this.callback}>
              <Panel header="MEMBER FINANCIAL STATEMENT REPORT" key="1">

              <div style={{display:'flex',justifyContent:'flex-start'}}>
                            
              <ReactToPrint
                trigger={() => 
                <Button type="primary"  shape="round" icon={<PrinterOutlined />} size={this.state.size}>
                Print
                </Button>
                }
                content={() => this.componentRef}
                />
                &nbsp;
                &nbsp;
                &nbsp;
                &nbsp;
                &nbsp;

              <Button type='primary'
                icon={<MailFilled/>}
                
                onClick={
                ()=>{
                  let form_data = new FormData();
                  form_data.append('dateone', this.state.dateone);
                  form_data.append('datetwo', this.state.datetwo);
                  form_data.append('memberid', this.state.selectedmemberid);
                  form_data.append('sacco', sacco);

                  form_data.append('showall', this.state.showall);

                  form_data.append('showsavings', this.state.showsavings);
                  form_data.append('showshares', this.state.showshares);
              
                  form_data.append('showloan', this.state.showloan);
                  form_data.append('showsavingsloansecurity', this.state.showsavingsloansecurity);
                  form_data.append('showfixeddeposit', this.state.showfixeddeposit);
              
                  form_data.append('showloan_interest', this.state.showloan_interest);
                  form_data.append('showloan_fine', this.state.showloan_fine);
                  form_data.append('showsavings_interest', this.state.showsavings_interest);
                  form_data.append('show_accumulateddividends', this.state.show_accumulateddividends);

                  
                  console.log(this.state.entrant)
                    
                  if(this.state.selectedmemberid===''||this.state.dateone===''||this.state.datetwo===''){
                    alert("Please select entrant or dates missing")
                  }else{
                      this.setState({datarequested:true})
              
                      //Now submit sale data to database
                      axios.post(serverconfig.backendserverurl+'/customqueries/emailmemberfinancialstatement', form_data,{
                      headers: {
                        'content-type': 'multipart/form-data'
                      }
                      })
                      .then(res =>{
                        this.setState({datarequested:false})
                        message.info(res.data.message)
                      } 
                      )
                      .catch(error => console.log(error))   
                  }
                }
                }
                
                >
                Send via eMail
              </Button>

          

              </div>
              <br></br>
              <br></br>
              <h3>{this.state.selectedmemberobject.FullName} | {this.state.selectedmemberobject.AccountNumber} </h3>
              <br></br>

              <Form  layout="inline" >

                  <FormItem label="Date Range">
                      <RangePicker defaultValue={moment()} onChange={this.handledatechange} format={dateFormat} />
                  </FormItem>
  
                  <FormItem>
                  <Button onClick={this.searchSales} type="primary" htmlType="button">Search</Button>
                  </FormItem> 
  
             </Form>


             <br></br>
<Form layout='inline'>

<FormItem name="showall" label="Show all" >
                        <Switch
                            checked={this.state.showall}
                            onChange={val=>{
                              this.setState({showall:val})

                              if (val===true){
                                this.setState({showsavings:true})
                                this.setState({showsavings_interest:true})

                                this.setState({showshares:true})
                                this.setState({showsavingsloansecurity:true})
                                this.setState({showfixeddeposit:true})

                                this.setState({showloan:true})
                                this.setState({showloan_fine:true})
                                this.setState({showloan_interest:true})

                                if(this.state.companyprofile.accumulated_dividends_active===true){
                                  this.setState({show_accumulateddividends:true})

                                }

                              }else{
                                this.setState({showsavings:false})
                                this.setState({showsavings_interest:false})

                                this.setState({showshares:false})
                                this.setState({showsavingsloansecurity:false})
                                this.setState({showfixeddeposit:false})

                                this.setState({showloan:false})
                                this.setState({showloan_fine:false})
                                this.setState({showloan_interest:false})   
                                
                                if(this.state.companyprofile.accumulated_dividends_active===true){

                                this.setState({show_accumulateddividends:false})
                                }

                              
                              }

                            }}
                            checkedChildren="ON"
                            unCheckedChildren="OFF"
                        />
                    </FormItem>

                 <FormItem name="showsavings" label="Show savings" >
                        <Switch
                            checked={this.state.showsavings}
                            onChange={val=>{this.setState({showsavings:val})}}
                            checkedChildren="ON"
                            unCheckedChildren="OFF"
                        />
                    </FormItem>


                    <FormItem name="showsavings_interest" label="Show savings interest" >
                        <Switch
                            checked={this.state.showsavings_interest}
                            onChange={val=>{this.setState({showsavings_interest:val})}}
                            checkedChildren="ON"
                            unCheckedChildren="OFF"
                        />
                    </FormItem>

                    <FormItem name="showshares" label="Show shares" >
                        <Switch
                            checked={this.state.showshares}
                            onChange={val=>{this.setState({showshares:val})}}
                            checkedChildren="ON"
                            unCheckedChildren="OFF"
                        />
                    </FormItem>

                    <FormItem name="showloan" label="Show loan" >
                        <Switch
                            checked={this.state.showloan}
                            onChange={val=>{this.setState({showloan:val})}}
                            checkedChildren="ON"
                            unCheckedChildren="OFF"
                        />
                    </FormItem>

                    <FormItem name="showloan_interest" label="Show loan interest" >
                        <Switch
                            checked={this.state.showloan_interest}
                            onChange={val=>{this.setState({showloan_interest:val})}}
                            checkedChildren="ON"
                            unCheckedChildren="OFF"
                        />
                    </FormItem>

                    <FormItem name="showloan_fine" label="Show loan fine" >
                        <Switch
                            checked={this.state.showloan_fine}
                            onChange={val=>{this.setState({showloan_fine:val})}}
                            checkedChildren="ON"
                            unCheckedChildren="OFF"
                        />
                    </FormItem>
 
                    <FormItem name="showsavingsloansecurity" label="Show savings loan security (Reserve)" >
                        <Switch
                            checked={this.state.showsavingsloansecurity}
                            onChange={val=>{this.setState({showsavingsloansecurity:val})}}
                            checkedChildren="ON"
                            unCheckedChildren="OFF"
                        />
                    </FormItem>


                    <FormItem name="showfixeddeposit" label="Show fixed deposit" >
                        <Switch
                            checked={this.state.showfixeddeposit}
                            onChange={val=>{this.setState({showfixeddeposit:val})}}
                            checkedChildren="ON"
                            unCheckedChildren="OFF"
                        />
                    </FormItem>


                    {
                        this.state.companyprofile.accumulated_dividends_active?
                        <FormItem name="show_accumulateddividends" label="Show accumulated dividends" >
                          <Switch
                              checked={this.state.show_accumulateddividends}
                              onChange={val=>{this.setState({show_accumulateddividends:val})}}
                              checkedChildren="ON"
                              unCheckedChildren="OFF"
                          />
                      </FormItem>
                        :
                        null
                      }


</Form>



  
             <br></br>
             <div style={{overflowX : 'auto'}}>
             <reactstrp.Table bordered>
        <thead>
          <tr>
            <th>No</th>
            <th>Date</th>
            <th>Desc</th>
            <th>Sub account</th>

            <th>Debit</th>
            <th>Credit</th>
            

            {this.state.showsavings?<th>Savings balance</th>:null}
            {this.state.showsavings_interest?<th>Savings interest</th>:null}

            {this.state.showshares?<th>Shares #</th>:null}
            {this.state.showshares?<th>Shares Amount</th>:null}
            {this.state.showloan?<th>Loan balance</th>:null}
            {this.state.showloan_interest?<th>Loan interest</th>:null}
            {this.state.showloan_fine? <th>Loan fine</th>:null}

            {this.state.showfixeddeposit? <th>Fixed deposit</th>:null}
            {this.state.showsavingsloansecurity? <th>Savings loan security</th>:null}
            {this.state.show_accumulateddividends? <th>Accumulated dividends</th>:null}

            <th>Journal number</th>

        

          </tr>
        </thead>
        <tbody>
        {this.state.sheetitems.map(
          (item)=>(
            <tr>
            <td>{item.item_no}</td>

            <td>{item.time_stamp}</td>
            <td>{item.description}</td>
            <td>{item.subaccount}</td>

            <td className="align-right">{<CurrencyFormat value={item.debit} displayType={'text'} thousandSeparator={true}/>}</td>
            <td className="align-right">{<CurrencyFormat value={item.credit} displayType={'text'} thousandSeparator={true}/>}</td>
           

            {this.state.showsavings?<td className="align-right">{<CurrencyFormat value={item.savings_balance} displayType={'text'} thousandSeparator={true}/>}</td>:null}
            {this.state.showsavings_interest?<td className="align-right">{<CurrencyFormat value={item.saving_interestbalance} displayType={'text'} thousandSeparator={true}/>}</td>:null}

            {this.state.showshares?<td className="align-right">{item.sharesnumber_balance} </td>:null}
            {this.state.showshares?<td className="align-right">{<CurrencyFormat value={item.sharesamount_balance} displayType={'text'} thousandSeparator={true}/>}</td>:null}
            {this.state.showloan?<td className="align-right">{<CurrencyFormat value={item.loan_balance} displayType={'text'} thousandSeparator={true}/>}</td>:null}
            {this.state.showloan_interest?<td className="align-right">{<CurrencyFormat value={item.loaninterest_balance} displayType={'text'} thousandSeparator={true}/>}</td>:null}
            {this.state.showloan_fine? <td className="align-right">{<CurrencyFormat value={item.loanfine_balance} displayType={'text'} thousandSeparator={true}/>}</td>:null}

            {this.state.showfixeddeposit? <td className="align-right">{<CurrencyFormat value={item.fixed_deposit_balance} displayType={'text'} thousandSeparator={true}/>}</td>:null}
            {this.state.showsavingsloansecurity? <td className="align-right">{<CurrencyFormat value={item.savingsloan_security_balance} displayType={'text'} thousandSeparator={true}/>}</td>:null}
            {this.state.show_accumulateddividends? <td className="align-right">{<CurrencyFormat value={item.accumulated_dividendsbalance} displayType={'text'} thousandSeparator={true}/>}</td>:null}

            <td>{item.journal_no} </td>



            </tr>
          ))}

        <tr>



        {this.state.showsavings?<td className="align-right"><h3>Savings: <CurrencyFormat  value={this.state.selectedmemberobject.savings_balance} displayType={'text'} thousandSeparator={true} /></h3> </td>:null}
            {this.state.showsavings_interest?<td className="align-right"><h3>Savings interest: <CurrencyFormat  value={this.state.selectedmemberobject.saving_interestbalance} displayType={'text'} thousandSeparator={true} /></h3> </td>:null}

            {this.state.showshares?<td className="align-right"><h3>Shares no : {this.state.selectedmemberobject.sharesnumber_balance}</h3></td>:null}
            {this.state.showshares?<td className="align-right"> <h3>Shares amount  : <CurrencyFormat  value={this.state.selectedmemberobject.sharesamount_balance} displayType={'text'} thousandSeparator={true} /></h3></td>:null}
            {this.state.showloan?<td className="align-right"><h3>Loan : <CurrencyFormat  value={this.state.selectedmemberobject.loan_balance} displayType={'text'} thousandSeparator={true} /></h3></td>:null}
            {this.state.showloan_interest?<td className="align-right"><h3>Loan interest : <CurrencyFormat  value={this.state.selectedmemberobject.loaninterest_balance} displayType={'text'} thousandSeparator={true} /></h3></td>:null}
            {this.state.showloan_fine? <td className="align-right"><h3>Loan fine : <CurrencyFormat  value={this.state.selectedmemberobject.loanfine_balance} displayType={'text'} thousandSeparator={true} /></h3></td>:null}

            {this.state.showfixeddeposit? <td className="align-right"><h3>Fixed deposit : <CurrencyFormat  value={this.state.selectedmemberobject.fixed_deposit_balance} displayType={'text'} thousandSeparator={true} /></h3></td>:null}
            {this.state.showsavingsloansecurity? <td className="align-right"><h3>Reserve (Savings loan security) : <CurrencyFormat  value={this.state.selectedmemberobject.savingsloan_security_balance} displayType={'text'} thousandSeparator={true} /></h3></td>:null}
            {this.state.show_accumulateddividends? <td className="align-right"><h3>Accumulated dividends : <CurrencyFormat  value={this.state.selectedmemberobject.accumulated_dividendsbalance} displayType={'text'} thousandSeparator={true} /></h3></td>:null}


            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>

          </tr>

      </tbody>
  </reactstrp.Table>

              </div>
             

              </Panel>
              </Collapse>

          </div>
      )        

      }
   
   }
}

export default FinancialStatementReportPerMember; 
